let contactSubmitElement;

export default function () {
    const contactFormElement = document.forms['contact'];
    contactSubmitElement = document.querySelector('#contact-submit');

    if (!contactFormElement || !contactSubmitElement) {
        return;
    }

    bindSubmitEvent(contactFormElement);
    bindFocusEvent(contactFormElement);
}

function bindSubmitEvent (contactFormElement) {
    contactFormElement.addEventListener('submit', e => {
        e.preventDefault();

        clearFieldsClasses();

        const data = serializeFormData(contactFormElement);
        const headers = prepareHeaders(data['_token']);

        contactSubmitElement.disabled = true;
        contactSubmitElement.textContent = 'Wysyłanie...';
        submitForm(data, headers)
            .then(response => {
                if (response.success) {
                    success(contactFormElement);
                }

                contactSubmitElement.disabled = false;
                contactSubmitElement.textContent = 'Wyślij';
            })
    })
}

function bindFocusEvent (contactFormElement) {
    Object.keys(contactFormElement.elements).forEach(key => {
        contactFormElement.elements[key].addEventListener('focus', e => {
            e.currentTarget.parentElement.classList.remove('field-error');
        })
    })
}
function success (contactFormElement) {
    contactFormElement.classList.add('contact-form--success');

    setTimeout(function() {
        contactFormElement.classList.remove('contact-form--success');
    }, 5000);

    Object.keys(contactFormElement.elements).forEach(key => {
        if (contactFormElement.elements[key].type !== 'hidden') {
            contactFormElement.elements[key].value = '';
        }
    });
}

function submitForm(data, headers) {
    return fetch ('/contact', {
        method: 'POST',
        headers,
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return {
                success: true
            };
        } else {
            return response.json();
        }
    }).then(validate)
        .catch(console.error);
}

function validate (errors) {
    Object.keys(errors).forEach(error => {
        let fieldElement = document.querySelector(`#${error}`);
        if (fieldElement) {
            fieldElement.parentElement.classList.add('field-error');
            fieldElement.parentElement.dataset.error = errors[error][0];
        }
    });

    return errors;
}

function clearFieldsClasses() {
    const errorFieldsElements = document.querySelectorAll('.field-error');
    errorFieldsElements.forEach(field => {
        field.classList.remove('field-error');
    });
}

function serializeFormData (contactFormElement) {
    const formEntries = new FormData(contactFormElement).entries();
    return Object.assign(...Array.from(formEntries, ([x,y]) => ({[x]:y})));
}

function prepareHeaders (token) {
    let headers =  {
        "Content-type": "application/json; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest",
    };

    if (token) {
        headers["X-CSRF-TOKEN"] = token;
    }

    return headers;
}
